/* import __COLOCATED_TEMPLATE__ from './highlight.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();